import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Colors } from '@/constants/colors';
import { ComprehensiveStockAnalysis } from '@/types/perplexity.types';
import { SkeletonCard } from './SkeletonCard';

interface RecentDevelopmentsCardProps {
  data: ComprehensiveStockAnalysis['recentDevelopments'] | null | undefined;
  isLoading: boolean;
}

export const RecentDevelopmentsCard: React.FC<RecentDevelopmentsCardProps> = ({
  data,
  isLoading,
}) => {
  if (isLoading || !data || data.length === 0) {
    return <SkeletonCard lines={4} />;
  }

  return (
    <View style={styles.card}>
      <View style={styles.cardHeader}>
        <Ionicons name="newspaper" size={20} color={Colors.primary} />
        <Text style={styles.cardTitle}>Recent Developments</Text>
      </View>

      {data.map((development, index) => (
        <View key={index} style={styles.bulletItem}>
          <Text style={styles.bullet}>•</Text>
          <Text style={styles.bulletText}>{development}</Text>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: Colors.background.secondary,
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
    borderWidth: 1,
    borderColor: Colors.border.subtle,
  },
  cardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
    gap: 8,
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: Colors.text.primary,
    flex: 1,
  },
  bulletItem: {
    flexDirection: 'row',
    marginBottom: 10,
  },
  bullet: {
    fontSize: 14,
    color: Colors.primary,
    marginRight: 8,
    marginTop: 2,
  },
  bulletText: {
    flex: 1,
    fontSize: 14,
    lineHeight: 20,
    color: Colors.text.primary,
  },
});
